import { InvoiceTaxModel } from './invoicetax.model';

export class InvoiceLineModel {
    product: string;
    conceptUid: string;
    conceptCode: string;
    quantity: number;
    discount: number;
    unityAmount: number;
    netPrice: number;
    position: number;
    totalLine: number;

    masterMeasurableUid?: string;
    masterUnitMeasurableUid?: string;
    isMeasurable: boolean;
    quantityMeasurable: number;
    taxes: Array<InvoiceTaxModel>;

    constructor() {
        this.taxes = new Array<InvoiceTaxModel>();
        this.discount = 0;
        this.quantity = 1;
        this.unityAmount = 0;
        this.totalLine = 0;
    }
}
